import { useQuery } from "@apollo/client";
import { DocumentDetailsDocument } from "../../../../../../__generated__/graphql";

export default function useDocumentDetails(documentId?: string | null) {
  const { data, loading, error } = useQuery(DocumentDetailsDocument, {
    variables: { documentId: documentId ?? "" },
    skip: !documentId,
  });

  return { data, loading, error };
}
